__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/06174f96c5ca5ab1f3303fa9e5d599dea01d388b37c0d403eb581b34/";